export const POWERLINE_GROUP_HIGHLIGHT_COLOR = 'white';
export const POWERLINE_GROUP_COLOR = 'blue';

export const POWERLINE_GROUP_POLYLINE_SHAPE_OPTIONS = {
  color: POWERLINE_GROUP_COLOR,
  weight: 4,
  opacity: 1,
  fillOpacity: 1,
}
